import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthFrame } from '../../components/AuthFrame';
import { requireSupabase } from '../../lib/supabase';

export function ResetPasswordPage() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const submit = async (event: FormEvent) => {
    event.preventDefault(); setMessage('');
    const { error } = await requireSupabase().auth.updateUser({ password });
    if (error) setMessage(error.message);
    else navigate('/hub');
  };
  return (
    <AuthFrame eyebrow="Secure your account" title="Choose a new password" description="Use at least eight characters and something you don’t reuse elsewhere.">
      <form className="auth-form" onSubmit={submit}>
        <label>New password<input type="password" minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} required /></label>
        {message && <div className="form-message">{message}</div>}
        <button className="button primary full">Update password</button>
      </form>
    </AuthFrame>
  );
}
